module.exports = __webpack_public_path__ + "img/Group 2801.677898c2.svg";